import {
  INCORRECT_CREDENTIALS,
  INVALID_VERIFICATION_CODE,
  NOT_AUTHORIZED,
  SERVER_ERROR,
  TOO_MANY_REQUESTS,
  USER_ALREADY_EXISTS,
  USER_NOT_CONFIRMED,
  USER_NOT_FOUND,
} from '../constants/authMessages';
import { AuthErrorResponseMessages, IError } from '../types/auth';

export const validateEmail = (email: string) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validatePassword = (password: string) => {
  const re = /^.*(?=.{8,})(?=.*[A-Z])(?=.*[a-z]).*$/;
  return re.test(password);
};

export const translateErrorMessage = (error: IError) => {
  switch (error.code) {
    case AuthErrorResponseMessages.USER_NOT_FOUND: {
      return USER_NOT_FOUND;
    }

    case AuthErrorResponseMessages.INCORRECT_CREDENTIALS: {
      return INCORRECT_CREDENTIALS;
    }

    case AuthErrorResponseMessages.USER_ALREADY_EXISTS: {
      return USER_ALREADY_EXISTS;
    }

    case AuthErrorResponseMessages.INVALID_VERIFICATION_CODE: {
      return INVALID_VERIFICATION_CODE;
    }

    case AuthErrorResponseMessages.SERVER_ERROR: {
      return SERVER_ERROR;
    }

    case AuthErrorResponseMessages.NOT_AUTHORIZED: {
      return NOT_AUTHORIZED;
    }

    case AuthErrorResponseMessages.TOO_MANY_REQUESTS: {
      return TOO_MANY_REQUESTS;
    }

    case AuthErrorResponseMessages.USER_NOT_CONFIRMED: {
      return USER_NOT_CONFIRMED;
    }

    default:
      return error.message;
  }
};
